import React, { useState } from "react";
// import programs from "../../../constants/programs.json"
// import CallToAction from "./call-to-action";
// import { MdArrowOutward } from "react-icons/md";
import BackdropLoader from "../../loaders/backdrop-loader";
import NoEnrollmentsState from "../../NewDashboard/components/NoEnrollmentsState";
import Layout from "../../NewDashboard/Layout";

const DashboardWithoutEnrollments = () => {
  return (
    <Layout initialCollapsed={false}>
      <div className="w-full font-circular h-full flex items-center justify-center">
        <NoEnrollmentsState variant="dashboard" />
        {/* <div className='w-full py-12 xl:px-12 px-4'>
                <div className='max-w-[85rem] w-full mx-auto'>
                    <div className="flex gap-8 mt-8">
                        <div className='flex-1 xl:flex-[0.7]'>
                           
                        </div>
                        
                    </div>
                </div>
            </div> */}
        {/* <BackdropLoader open={false} /> */}
      </div>
    </Layout>
  );
};
export default DashboardWithoutEnrollments;
